import { AxiosInstance } from 'axios';

export enum MenuRouting {
  CABINET = 'profile-cabinet',
  SETTINGS = 'profile-settings',
  MENTORING = 'profile-mentoring',
  NOTIFICATIONS = 'profile-notifications',
  REQUESTS = 'mentoring',
}
export interface IProfileMenu {
  $api: AxiosInstance;
  readonly cabinet: string;
  readonly settings: string;
  readonly notifications: string;
  unreadCounter: number;
  isActiveCabinet: boolean;
  isActiveSettings: boolean;
  isActiveNotifications: boolean;
  unreadCount: string | number;
  created: () => void;
  logout: () => void;
  getUnread: () => Promise<void>;
}



// WEBPACK FOOTER //
// ./src/pages/profile/profilemenu/types.ts